import {
  boardFilterChips,
  boardFiltersAreActive,
  clearBoardFilterChip,
  clearBoardFilters,
  type CampaignFilters,
} from "../campaignFilters";

export function WorkspaceActiveFilters({
  filters,
  onChange,
}: {
  filters: CampaignFilters;
  onChange: (next: CampaignFilters) => void;
}) {
  const chips = boardFilterChips(filters);
  const canClear = boardFiltersAreActive(filters);
  if (!chips.length && !canClear) return null;

  return (
    <div className="workspace-active-filters" aria-label="Active filters">
      {chips.map((chip) => (
        <span key={chip.id} className="workspace-filter-chip">
          <span className="workspace-filter-chip-label">{chip.label}</span>
          <button
            type="button"
            className="workspace-filter-chip-clear"
            aria-label={`Remove ${chip.label} filter`}
            onClick={() => onChange(clearBoardFilterChip(filters, chip.id))}
          >
            <svg width="10" height="10" viewBox="0 0 14 14" aria-hidden="true">
              <path
                d="M2 2l10 10M12 2L2 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </span>
      ))}
      {canClear ? (
        <button
          type="button"
          className="ghost workspace-filter-clear-all"
          aria-label="Clear all filters"
          onClick={() => onChange(clearBoardFilters(filters))}
        >
          Clear filters
        </button>
      ) : null}
    </div>
  );
}
